/* eslint-disable */
const en = {
  test: "This is EN",
  submitted: "Submitted",
  email: "Email",
  birth: "Birth",
  gender: "Gender",
  last_name: "Last Name",
  first_name: "First Name",
  postal_code: "Postal Code",
  zip: "Postal Code",
  province: "Province",
  city: "City",
  address1: "Address 1",
  address2: "Address 2 (Optional)",
  phone_number: "Phone Number",
  search_address: "Search Address",
  save: "Save",
  cancel: "Cancel",
  edit: "Edit",
  delete: "Delete",
  subtotal: "Subtotal",
  shipping_fee: "Shipping Rate",
  discount: "Discount",
  total_amount: "Total",
  refunded_amount: "Refunded",
  cancel_order: "Cancel Order",
  request_return: "Request Return",
  tracking_number: "Tracking Number",
  payment_method: "Payment Method",
  male: "Male",
  female: "Female",
  "non-binary": "Non Binary",
  current_password: "Current Password",
  new_password: "New Password",
  confirm_new_password: "Confirm New Password",
  view_detail: "View Detail",
  confirm: "Confirm",
  submit: "Submit",
  deactivate: "Deactivate",
  password: "Password",
  notification: "Notification",
  gift: "Gift",
  change: "Change",
  popup_close: "Hide for 24h",
  return_shipping: "Return shipping",
  order_status: {
    title: "Status",
    refunded: "Refunded",
    canceled: "Canceled",
    partially: "Partially Refunded",
    completed: "Completed",
    return: "Return Requested",
    return_approved: "Return Approved",
    shipped: "Shipped",
    partially_shipped: "Partially Shipped",
    scheduled: "On Hold",
    scheduled_shipped: "Scheduled Shipped",
    completed_shipped: "Complete Shipment",
    preparing: "Processing",
    pending: "Payment Pending",
    paid: "Paid",
    prizeCancel: "Winning cancelled",
    drawCancel: "Entry cancelled",
    drawLose: "Not selected",
    drawWin: "**Winner**",
    drawApply: "Entry complete",
    gifting_pending: "Awaiting gift acceptance",
    gifting_accepted: "Gift accepted",
    preorder: "Preorder",
  },
  account: {
    reset_password_email: "Send an email to reset your password.",
    login: "Sign in with Email",
    order_history: "Order History",
    draw_history: "Draw Entry History",
    event_history: "Event History",
    shipping_address: "Manage Addresses",
    log_out: "Log Out",
    new_collection: "Shop New Arrivals",
    return_history: "Return History",
    personal_information: {
      description:
        "You may check and edit your account information below.<br/>Please contact us via {{supportEmail}} or use the live chat service for any inquiries regarding orders and shipments.",
      accepts_marketing: "Please keep me updated on news, events, and offers. (optional)",
      update_information: "Update Information",
      employee: "account.",
    },
    reset_password: {
      description: "Send email to reset password.",
      request: "Change Password",
      title: "Reset Password",
    },
    forgot_password: {
      description: "Forgot your password? Reset here.",
      label: "Forgot Password",
    },
    create_account: {
      description: "I agree to terms and conditions and privacy policies.",
      label: "Create Account",
    },
    deactivation: {
      request:
        "Once your account deletion request is submitted, your account information will be permanently deleted and you will no longer be able to use the store services.",
      ask: "Are you sure you want to delete your account? Click 'Confirm' to proceed.",
      processing: "Processing",
      description:
        "Once your account deletion request is submitted, your account information will be permanently deleted and you will no longer be able to use the store services.",
    },
    social_login: {
      change_password: "This is the social login service currently connected.",
    },
    membership: {
      discount: "Benefit: {{amount}}",
      coupon: "Discount Code: Monthly code {{amount}}%",
      current: "Current Level",
      next: "Expected Level",
      view_detail: "View All Benefits",
      view_membership_detail: "Check My Membership",
      my_membership: "Membership Level",
      more_info: "View membership benefits",
      description_new: "Join the {{storeName}} membership for exclusive discounts and be the first to hear about new arrivals and events.",
      accumulated_amount1: "Your total over the past year is",
      accumulated_amount2: " ₩{{amount}}.",
      next_level_new1: "You need",
      next_level_new2: " ₩{{amount}} more to reach {{next_level}}.",
      benefit: {
        title: "Benefits",
        discount: "Ongoing {{discount}} Discount",
        code: "{{code}} Monthly Discount Code",
      },
      amount: {
        current: "{{amount}} spent",
        next: "{{amount}} to {{membership}}",
      },
      member: {
        discount_code: "",
        benefits: "Ongoing 1% discount",
        purchase_amount: "For purchases up to $299",
      },
      silver: {
        benefits: "Ongoing 3% discount",
        discount_code: "Monthly 5% discount code",
        purchase_amount: "For purchases between $300 and $1,999",
      },
      gold: {
        benefits: "Ongoing 5% discount",
        discount_code: "Monthly 7% discount code",
        purchase_amount: "For purchases between $2,000 and $4,999",
      },
      platinum: {
        benefits: "Ongoing 7% discount",
        discount_code: "Monthly 10% discount code",
        purchase_amount: "For purchases between $5,000 and $9,999",
      },
      vip: {
        benefits: "Ongoing 10% discount",
        discount_code: "Monthly 15% discount code",
        purchase_amount: "For purchases over $10,000",
      },
      employee: {
        discount_code: "",
        benefits: "Ongoing 50% discount",
      },
      policy: {
        "1": "Future Membership benefits and selection criteria may be subject to change, with or without prior notice.",
        "2": "Membership benefits are only applicable at the {{storeName}} online store.",
        "3": "Membership-exclusive discount codes will be issued at 11:00 AM on the 1st of each month and are valid for one-time use until 10:59 AM on the first day of the next month. (Please note that if you opt out of receiving the latest news and promotions or refuse the collection and use of personal data for promotional purposes, you may have limited access to various news and benefits.)",
        "4": "The membership levels are updated sequentially from 11:00 AM on the 1st of each month and are based on the actual cumulative purchase amount within the past 3 years.",
        "5": "Membership levels are based on the actual payment amount after excluding cancellations and refunds from the total order amount, calculated 7 days after the order date.",
        "6": "The actual payment amount refers to the net product amount after discount application, excluding shipping fees, customs duties, and taxes.",
        "7": "Only one discount code can be used in a single transatiction and cannot be used with other discount codes.",
        "8": "Some items are excluded from discounts.",
        "9": "Benefits associated with membership levels are non-transferable. (If there is suspicion of accumulating performance through fraudulent means, the membership level may be downgraded.)",
        "10": "Some discount codes may not be applicable to membership discounts at all times.",
        "11": "Issued codes expire upon use and cannot be reissued or restored.",
      },
      employee_discount: "Employee discount applied",
    },
    order: {
      none: "You have no orders.",
      amount: "Order total",
      invoice_number: "Tracking number",
      instagram: "Instagram account",
      insta: "Instagram",
      receive: "Delivery method",
      delivery: "Delivery",
      pickup: "Store pickup",
      charge: "Shipping",
      free: "Free shipping",
      total: "Subtotal",
      payment_method: "Payment method",
      payment: "Amount paid",
      address: "Shipping address",
      billing: "Billing address",
      wait_alert: "Processing your payment.\nPlease wait a moment.",
      pay: "Pay now",
      currency: "KRW",
      cancel_order: "Cancel order",
      return_order: "Request a return",
      count: "pcs",
      unwanted: "Changed my mind",
      defective: "Defective item",
      size_large: "Too large",
      size_small: "Too small",
      already: "You have already entered this raffle.",
    },
    draw: {
      none: "You have no entries.",
      auto_pay: "Auto-payment method",
      pickup_info: "Pickup details",
      cancel_draw: "Cancel entry",
      address: "Pickup location",
      default_address: "1F, 3 Seongsui-ro 7ga-gil, Seongdong-gu, Seoul",
      buy_period: "Purchase period",
      info: "Please note",
      info1: "Your win is forfeited if you do not purchase within the purchase period.",
      info2: "Payment is accepted only with a card in the winner's own name.",
      info3: "*Bring your entry confirmation and photo ID. Purchase or pickup on someone else's behalf is not allowed.",
      info4: "Returns and refunds are available; exchanges are not.",
      info5: "*Due to limited stock, defective items cannot be exchanged. Thank you for your understanding.",
      kakao_info: "If you win, we will send you the purchase period and instructions via KakaoTalk.",
      follow: "Only followers are eligible to win.",
      already: "You have already entered.",
      draw: "Enter",
      cancel_item_ask: "\nDo you want to cancel your entry for this product?",
    },
    info: {
      me: "My Information",
      agree: "Agree to receive marketing information along with the details below to enjoy a range of member benefits.",
      card: "Saved Cards",
      card_save: "Save and manage the cards you use often for a faster checkout.",
      password: "Change Password",
      password_info: "For your security, we recommend changing your password if it has not been updated in over a year.",
      social: "Social Login",
      social_current: "These are the social login services currently connected to your account.",
      delete: "Delete Account",
      delete_ask: "Are you sure you want to delete your account?\nPressing ‘Okay’ will permanently delete it.",
      current_password: "Current Password",
      new_password: "New Password",
      check_password: "Confirm Password",
      change_password: "Change password",
      marketing_agree: "Receive marketing information",
      save_card: "Manage saved cards",
      male: "Male",
      female: "Female",
    },
    shipping: {
      add: "Add address",
      add_address: "Add a default address to check out faster.",
      manage: "Manage addresses",
      manage_address: "Change your default address, or edit and delete saved addresses.",
      none: "You have no saved addresses.",
      edit: "Edit address",
      delete: "Delete address",
      delete_ask: "Do you want to delete this saved address?",
      new_address: "Add an address",
      continue: "Continue",
      address: {
        first_name: "First name",
        last_name: "Last name",
        zip: "Postal code",
        city: "City / State",
        address1: "Address",
        address2: "Apartment, suite, etc.",
        phone: "Phone number",
        set_default: "Set as default address",
        save: "Save",
        add: "Add",
        find: "Search address",
        default: "Default address",
      },
    },
    return: {
      order_id: "Order number",
      select_item: "Select the items you want to return.",
      back: "Back",
      method: "Please review how your returned items will be handled.",
      method_description: "If you prefer to ship the item yourself, please contact us via Channel Talk.",
      continue: "Submit return request",
      reason: "Reason",
      add_photo: "Attach a photo",
      select_reason: "Please select a return reason.",
    },
    checkout: {
      captcha: "Find and click T, U, N, E below.",
      save_card: "Save your card to check out faster. For a one-time payment, choose another payment method.",
    },
  },
  raffles: {
    empty: "You have no entries.",
  },
  order_history: {
    description:
      "Check your orders at a glance.<br/>Click on an order to find more detailed information, including delivery address and payment details.",
    empty: "You haven't placed any orders yet.",
  },
  wishlist: {
    description: "Save items to your wishlist for purchase later.",
    empty: "Your wishlist is empty.",
    none: "You have no items saved to your wishlist.",
    delete_ask: "Remove this item from your wishlist?",
  },
  address_book: {
    save_list: "Saved addresses",
    select_address: "Use this Address",
    create_new_address: "Add Address",
    edit_address: "Edit Address",
    set_as_default_address: "Set as the default address",
    description:
      "Save and manage your frequently used shipping addresses.<br/>By setting a default address, you can place orders more conveniently.",
    delete_address: "Do you really want to delete the shipping address?",
    save: "Save Address",
    save_continue: "Save and continue",
    change: "Change Address",
    use_other: "Other Address",
    empty_address: "There are no shipping addresses saved.",
    my_addresses: "My Addresses",
    default_address: "Default Address",
    change_address: "Use A Different Address",
    in_use: "In Use",
    empty: "No saved address yet.",
  },
  contact: {
    description: "Order cancellation, return requests, and delivery tracking are available under Order History in your Account.",
    order_history: "View Order History",
    my_membership: "View My Membership Tier",
    membership:
      "Your membership tier is updated on the 1st of each month based on your points from the past 12 months. Discover a variety of benefits.",
    working_hours: "Mon - Fri 10am - 5pm.",
    other_inquries: "{{supportEmail}}",
    cs_info: "Please contact us through channel talk or email.",
  },
  checkout: {
    discount_code_placeholder: "Enter your discount code.",
    create_shipping_address: "Create shipping address to complete order.",
    description:
      "All transactions are securely encrypted.<br/>Save your payment information for a more convenient online shopping experience. For regular payments, you may choose from any available payment methods. ",
    use_as_billing_address: "Use shipping address as billing address",
    pay_now: "Pay Now",
    consent: "I agree to the terms and conditions of the store and the third-party payment service provider(Toss Payments).",
    discount_code_alert: "* Discount codes do not apply to certain or collaborated items.",
    discount_code_alert_description:
      "Some collections are excluded from discounts, and codes won’t be reissued once the order has been cancelled.",
    wrong_customer_id: "Customer information does not match. Please log out of the current account and log in again with the same account.",
    wrong_cart_amount: "The cart amount does not match the payment amount.",
    wrong_discount_name: "This discount code is not valid",
    wrong_discount_code: "An invalid discount code has been applied. Please try again.",
    notice:
      "Please note that due to a system issue, duties and taxes of your order may be billed separately after your initial payment. We apologize for the inconvenience.",
    wrong_cart_changed: "Cart items, quantities, or prices have been updated. Please try again.",
    gifting_description: "Send a gift to someone special.<br/>Once your payment is complete, you can send the gift message via KakaoTalk.",
    gifting_card_message: "Write the message you would like to include with your gift.",
    gifting_recipient: "Please enter the recipient's real name where possible, so they can recognise that the gift was sent to them.",
    discount_input: "Type Discount Code",
  },
  cart: {
    discount: "Shipping fees and discount codes are applied at the checkout process.",
    empty: "Your cart is empty.",
    add_to_bag: "Add to Bag",
    go_to_checkout: "Proceed to Checkout",
    go_to_shop: "Continue Shopping",
    description: "Discount code will be applied in checkout.",
    delivery_benefit: "Delivery Benefit",
    free_shipping_at: "Free shipping at {{amount}}",
    free_shipping_remaining: "{{amount}} remaining",
    free_shipping_achieved: "This order qualifies for free shipping",
    checkout: "Checkout",
    preorder: "Preorder items must be purchased separately and cannot be combined with regular products.",
    amount: "Quantity",
  },
  order_completed: {
    description:
      "Your order has been successfully processed.<br/>Order details can be checked on the order history page, and you will be notified by email when the items are shipped.",
  },
  product: {
    restock_notification: {
      description: "Sign up to receive an email notification when this item is back in stock.",
    },
    membership_auto_discount_notice: "Membership tier discounts are not applicable to this product.",
    discount_code_unavailable_notice: "Discount codes cannot be applied to this product.",
    pigment_warning: "Please be careful while washing and wearing the item. It may cause discoloration.",
    preorder_description:
      "Pre-order items cannot be combined with regular products due to different shipping schedules. Please purchase pre-order items separately on this page.",
    shipping: {
      description:
        "Method: Yamato, YTO, SF and DHL<br/>Zone: International<br/>Rate: Based on total order weight<br/>Note: Shipping to Russia and Ukraine is temporarily unavailable.<br/><br/>If you are not satisfied with our products, you can return them. Please submit a return request through your {{storeName}} account. It must be done within 30 days of the original shipment date.<information>{{domain}}</information>",
    },
    pre_order_warning:
      "Pre-order items can only be purchased on their own.<br/>Adding this item to your cart will remove the regular items already in it.",
    normal_items_warning:
      "Pre-order items can only be purchased on their own.<br/>Adding this item to your cart will remove the pre-order items already in it.",
  },
  collection: {
    empty: "Sorry, there are no items available on this page.",
    ready: "The items in this collection are being prepared.",
  },
  return: {
    reason: "Reasons",
    request: "Submit Request",
    request_description: "The refund amount may vary depending on the condition of the product, and the return request may be denied.",
    detail_reason: "Details",
    description:
      "Please select the item you wish to return and the reason.<br/>You may request returns within 7 days of receiving your order.",
    requested_description:
      "Please select the item and reason for the return.<br/>Returns can only be requested within 7 days of placing the order.",
    view_policy: "Read Shipping & Returns Policy",
    detail_description: "Please provide detailed information. (Optional)",
    additional_description:
      "Please confirm the item and the reason for your return request.</br>The return request may be rejected when it does not comply with the terms and conditions.",
    image_description: "Please upload an image regarding faulty item.",
    add_image: "Please upload the images.",
    select_reason: "Please select the reason for the return.",
    unwanted_notice:
      "For returns due to a change of mind, the original shipping fee is non-refundable. Any customs clearance service fees incurred when the returned items re-enter Korea are the customer’s responsibility and will not be covered by thisisneverthat.",
    refund_shipping_notice: "A shipping fee may apply for returns due to {{reason}}.",
    disabled_product: "For returns of this item, please contact us via Channel Talk.",
    upload_image: "Please upload an image...",
    gift_description: "Gift with purchase will be selected automatically based on the condition.",
    return_reason: {
      title: "Return reason",
      unwanted: "Changed my mind",
      default: "Select a reason",
      defective: "Faulty Item or Wrong item delivered",
      size_large: "Too big",
      size_small: "Too small",
    },
    reasons: {
      defective: "Faulty Item or Wrong item delivered",
      unwanted: "Changed my mind",
    },
    optional: "optional",
  },
  return_requested: {
    description: "The return request has been successfully completed.<br/>Further notice will be delivered via email.",
    estimated_period: "Up to 7 days",
    button: "View Shipping & Return Policy",
    additional_charge:
      "*If the purchase price of the item you're returning is less than the return shipping fee, you have to pay additional shipping fee for return.",
    title: "Return is requested.",
    estimated_refund_amount: "Estimated refund Amount",
    return_deadline: "Return Deadline",
    return_shipping_fee: "Return Shipping Fee",
  },
  search: {
    empty: 'No results found for "{{value}}". Please try a different search term.',
    view_all: "View All",
    placeholder: "Search Here.",
    alert: "Please enter a search term.",
    no_matches: "No products match your search.",
  },
  membership: {
    title: "Enjoy exclusive discounts, early access to new arrivals, and event updates with the {{storeName}} Membership.",
    higher: "{{currency}}{{amount}} or more",
    lower: "Less than {{currency}}{{amount}}",
    discount: "Ongoing discount {{amount}}%",
    discount_rate: "Ongoing Discount",
    coupon: "Monthly code {{amount}}%",
    total_spent: "cumulative purchase amount",
    left: "You are ${{amount}} away from the next level.",
    total: "Your cumulative purchase amount is ₩{{amount}}.",
    view_membership: "View my membership information",
    description_text:
      "Discover ongoing discount benefits, along with various discount codes and exclusive content, available only to membership members.",
    current_membership: "The membership level of {{first_name}} {{last_name}} is <membership>{{membership}}</membership>",
    monthly_discount_code: "Monthly Discount Code",
    description: {
      "1": "Membership benefits are only applicable to the {{storeName}} online store.",
      "2": "Membership levels are determined based on the accumulated amount within one year from the month of change on the 1st of each month.",
      "3": "The accumulated amount is calculated based on the actual payment amount. However, according to the order terms, the accumulated amount is counted from 7 days after the order date.",
      "4": "Certain products may be excluded from discounts and benefits.",
      "5": "Issued codes expire upon use and cannot be reissued or restored.",
      "6": "Issued codes expire upon use and cannot be reissued or restored.",
    },
    policy: {
      "2": "Membership benefits are only applicable at the {{storeName}} online store.",
      "3": "Membership-exclusive discount codes will be issued at 11:00 AM on the 1st of each month and are valid for one-time use until 11:59 PM on the last day of the same month. (Please note that if you opt out of receiving the latest news and promotions or refuse the collection and use of personal data for promotional purposes, you may have limited access to various news and benefits.)",
      "4": "The membership levels are updated sequentially from 11:00 AM on the 1st of each month and are based on the actual cumulative purchase amount within the past 1 years.",
      "6": "The actual payment amount refers to the net product amount after discount application, excluding shipping fees, customs duties, and taxes.",
      "7": "Only one discount code can be used in a single transaction and cannot be used with other discount codes.",
      "10": "Some discount codes may not be applicable to membership discounts at all times.",
      "11": "Issued codes expire upon use and cannot be reissued or restored.",
    },
  },
  success: {
    password_reset_email: "An email has been sent to reset your password.",
    password_reset_social_email: "Password resets are not available for accounts created with social sign-ins.",
    newsletter_subscribe_message: "You can subscribe to the newsletter once you verify your email.",
    copy_url: "The item URL has been copied to your clipboard.",
    copy_url_message: "Paste your URL to share the items to others.",
    modify_account_info: "Changes are saved",
    verification: "Identity verification is complete.",
    raffle_entry: "Your entry has been submitted.",
    payment: "    Your payment was successful",
    newsletter_subscribe: "A confirmation email has been sent for your newsletter subscription.",
    login: "Successfully signed in.",
    restock: "We'll let you know when the item is back in stock.",
    wishlist_add: "Added to wishlist.",
    wishlist_remove: "Deleted from your wishlist.",
    address_remove: "Address has been removed.",
    logout: "Successfully signed out.",
    cancel_order: "The order has been canceled.",
    adult_verification: "Age verification is complete.",
    validate_toss: "Toss employee verification is complete.",
    password_change: "Your password has been changed. Please log in again.",
    register_complete: "Successfully signed up.",
    copy: "Copied to clipboard.",
  },
  warning: {
    login: "Incorrect email address or password.",
    phone: "A valid phone number required.",
    add_cart: "You have exceeded the available quantity.",
    payment_cancel: "The payment in process has been canceled. Please try again to complete the payment.",
    quantity_limit: "You have exceeded the available quantity.",
    quantity_insufficient:
      "The quantity of the item you are trying to order exceeds the available stock during the ordering process. The quantity will be adjusted in your cart, and out-of-stock items will be removed.",
    necessary_shipping_address: "Please fill out the shipping address.",
    necessary_billing_address: "Please fill out the billing address.",
    necessary_invalid_shipping_address: "There is a problem with your address. Please check your details and try again.",
    necessary_payment_data: "Payment information is not available. Please try again.",
    necessary_payment_method: "Please select a payment method.",
    no_return_for_gift: "Only gifts earned from the purchase cannot be returned.",
    no_return_product: "Please select the item you wish to return.",
    no_reason: "Please select the item you wish to return.",
    no_returnable_product:
      "There are items in your order that cannot be returned at this time. Please contact customer service for assistance with these items.",
    same_account_info: "Please enter information different from existing customer data.",
    invalid_cart: "No items available for purchase.",
    reusable_bag_limit: "Reusable Carrier Bags cannot be purchased individually.",
    end_session: "Your session has expired. Please log in again.",
    fail_calculate_order: "Order calculation has not been processed. Please try again.",
    already_restock: "This email has already been registered for restock notifications.",
    phone_taken: "    This phone number is already registered.",
    no_quantity_product: "This item cannot be returned.",
    gifting_necessary_receiver_name: "Please enter the recipient's name.",
    gifting_necessary_sender_phone: "Please save your phone number on the account page (<a>{{storeDomain}}/account</a>) and try again.",
    gifting_necessary_message_content: "Please enter a gift message.",
    no_login: "Sign in is required.",
    no_cart: "Your cart is empty.",
    remove_product: "You must select more than one item for return.",
    over_product: "The maximum number of items eligible for return has been selected.",
    not_match_password: "Please enter your current password correctly.",
    same_password: "Please enter a password different from the current one.",
    no_detail_reason: "Please provide the detailed reason for the return.",
    no_image: "Please upload an image for the return.",
    social_account: "This account is associated with {{social}}. Please use {{social}} sign in.",
    no_email: "This email address is not registered.",
    checkout_shipping_address_blocked:
      "The address you selected is not eligible for delivery due to our Terms of Service. Please use a different address.",
    empty_cart: "Your cart is empty. Redirecting to the previous page.",
    adult_only: "*Adults Only",
    exceed_purchase_limit:
      "Your cumulative order total plus the items in your cart exceeds the purchase limit. Please adjust the items or amount in your cart.",
    remaining_limit: "Maximum order amount available: ₩{{amount}}",
    fail_identity_verification: "Identity verification failed. Please try again.",
    need_identity_verification: "Identity verification was cancelled. Please try again to purchase this item.",
    request_identity_verification:
      "Your cart contains an item that requires age verification.<br/>Please complete identity verification to continue.",
    separate_required:
      "Your cart contains an item that requires age verification.<br/>This item cannot be purchased together with regular items, so please order it separately.",
    no_quantity_cart: "This product cannot be added to the cart because it is out of stock.",
    newsletter_empty_email_title: "Email address required.",
    already_feedback: "You have already participated in this survey.",
  },
  error: {
    already_used_discount_code: "This discount code has already been used.",
    failed_api_discount_code: "Failed to apply discount code. Please try again later.",
    not_found: "The URL does not exist.",
    payment: "Payment has failed. Please try again.",
    necessary_country: "Please fill in this field.",
    necessary_lastName: "Please fill in the Last Name field.",
    necessary_firstName: "Please fill in the First Name field.",
    necessary_city: "Please fill in the City field.",
    necessary_zip: "Please fill in the Zip field.",
    necessary_province: "Please fill in the Province field.",
    necessary_address1: "Please fill in the Address Line 1 field.",
    necessary_address2: "Please fill in the Address Line 2 field.",
    necessary_phone: "Please fill in the Phone field.",
    necessary_english: "Password must only contain special characters, numbers, and letters.",
    invalid_english: "field must be entered in English",
    invalid_japanese: "Please enter in Japanese.",
    invalid_phone: "Please enter your phone number accurately.",
    invalid_birthday: "Please enter your date of birth in the correct format.(e.g., MM/DD/YY)",
    necessary_password: "Please enter your password.",
    necessary_new_password: "Please enter your new password.",
    necessary_confirm_password: "Please re-enter your new password.",
    necessary_email: "Please enter your email address.",
    match_password: "The passwords do not match. Please try again.",
    necessary_consent: "Please agree to the privacy policy.",
    failed_no_return_product: "There are no eligible products for return.",
    exceed_qty: "The quantity exceeds the available stock.",
    already_delete_account: "This account is already in the process of being deactivated.",
    verification_error_description: "An error occurred while processing identity verification.",
    verification_error_failure: "Verification failed. Please try again.",
    verification_none: "This account has not been verified.<br/>Please complete a one-time identity verification.",
    raffle_already_entered: "You have already entered for this item.",
    raffle_error: "An error occurred while processing your entry.",
    blocked_address: "The address you selected cannot be shipped to under our terms of service. Please use a different address.",
    gifting_fetch_failed: "An error occurred while loading the gift information.",
    gifting_accept_failed: "An error occurred while accepting the gift. Please try again.",
    gifting_share_data: "An error occurred while loading the data needed to send the gift. Please try again.",
    server: "An error occurred on the server. Please try again.",
    search: "Please input a search term.",
    select_option: "Please choose an option.",
    discount_code: "Invalid discount code",
    cancel_order: "Order cancellation has not been processed. Please try again.",
    necessary_field: "Please fill in this field.",
    toss_payment: "An error occurred with the payment service. Please try again.",
    checkout: "An error occurred on the checkout. Please try again.",
    invalid_zip: "Please enter your zip code accurately.",
    invalid_phone_number: "Please enter your phone number accurately.",
    server_title: "An error occurred on the server. Please try again.",
    discount_code_title: "Invalid discount code",
    already_used_discount_code_title: "This discount code has already been used.",
    toss_payment_title: "An error occurred with the payment service. Please try again.",
  },
  login: {
    invalid_email: "Please use a verified email.",
    in_app_browser: "Notification",
    in_app_browser_message:
      "The browser you're using doesn't support social sign-in. Please sign in with your email or use a different browser.",
    account_disable:
      "This account is currently restricted because an account deletion request has been submitted.<br/>Your account and personal information will be automatically deleted within 1 to 30 days after your most recent order. Until the deletion process is complete, you cannot create a new account using the same email address.<br/>To continue using the store, please sign up with a different email address.",
    min_password: "Password must contain at least 5 characters.",
    social: "Social",
    kakao_continue: "Continue with Kakao",
    google_continue: "Continue with Google",
    social_continue: "Continue with social login",
    email_continue: "Continue with email",
    reset_password: "Reset Password",
    register: "Sign Up",
    cancel: "Cancel",
    login: "Log In",
    send_email: "Send Email",
    connect: "is connected to your account.",
    apply: "Apply",
    info: "Sign up with just an email and password to check out, track your orders and deliveries, and enjoy membership benefits.",
    personal_info: "I agree to the Privacy Policy and Terms of Service (required)",
    marketing_subscribe: "I agree to receive marketing information (optional)",
    auth: "Verify your identity",
    auth_ask: "For a more secure transaction,\nplease complete a one-time identity verification.",
    verificaton_error: "Verification failed.",
    description:
      "Become a member of the {{storeName}} online store.<br/>Enjoy monthly membership benefits and use the store more conveniently with features like payment, order history, and shipping tracking.",
    social_login_reset_password:
      "We will send a password reset link to your email.\nPlease change your password and try signing in with social login again.",
  },
  footer: {
    company1: "JKND Co., Ltd.",
    company2: "Business Registration No. 361-86-01005",
    company3: "CEO Jonathan",
    company4: "159 Achasan-ro, Seongdong-gu, Seoul, Republic of Korea (Seongsu-dong 2-ga, JKND)",
    company5: "070-4048-5375",
    company6: "Mail-Order Sales Registration No. 2024-Seoul Seongdong-1504",
  },
  information: {
    shipping: {
      method: "Method",
      method_description: "UPS, FedEx, Yamato, SF Express, and ZTO",
      zone: "Zone",
      zone_description: "International",
      time: "Rate",
      time_description: "Based on total order weight",
      description: "Shipping to Russia and Ukraine is temporarily unavailable.",
    },
    info1: "If you have any questions or need assistance, please contact us below.",
    info2: "To edit, cancel, or track your order, visit the order history page.",
    hours: "Hours",
    cs_time: "Mon - Fri 10am - 5pm",
    email: "{{serviceEmail}}",
    channel_talk: "{{channelTalkDomain}}",
  },
  news_letter: {
    accepts_marketing: "Please keep me updated on news, events, and offers. (optional)",
  },
  not_found: {
    description: "The requested URL was not found.",
  },
  events: {
    apply_form: "Submit Form",
    apply: "Apply Event",
    applied: "Thank you!",
    view_history: "View History",
    history_description: "*To change your details after applying, cancel your application from the link below and apply again.",
    applied_description: "Your application has been submitted. Thank you.",
    agreement: "I have read and agree to all of the above.",
    require_agreement: "Please accept the required terms.",
    option_default: "Select an option",
    info: "Applicant details",
    info_description: "Selected applicants will be contacted individually, so please enter a mobile number we can reach you at.",
    checkin_description: "Results are sent via KakaoTalk, so please enter a mobile number we can reach you at.",
    success_apply: "Your event application has been submitted.",
    success_cancel: "Your event application has been canceled.",
    already_applied: "You have already applied for this event.",
    closed: "The application period has ended.",
    failed_apply: "We couldn't submit your application. Please try again in a moment.",
    failed_cancel: "We couldn't cancel your application. Please try again in a moment.",
    cancel: "Cancel Application",
    empty: "You have no applications.",
    cancel_confirm: "Do you want to cancel your event application?",
  },
  modal: {
    cancel_order: {
      description: "Do you really want to cancel the order? The refund may take up to 14 days.",
    },
    gifting_send_message: {
      description: "Click the button below to send your gift via KakaoTalk.<br/>Your order is completed once the message is delivered.",
      button_description: "Send your gift via KakaoTalk.",
    },
  },
  return_reason: {
    wrong_item: "Wrong item delivered",
    defective: "Faulty Item",
    size_large: "Too big",
    size_small: "Too small",
    unwanted: "Changed my mind",
    default: "Other",
  },
  products: {
    recommendation: {
      newest: "Recently viewed",
      featured: "Recommended",
    },
    product: {
      desc: {
        title: "Description",
      },
      sizeChart: {
        title: "Size",
      },
      rtnExchDelivery: {
        title: "Shipping & Returns",
        description:
          "Standard delivery (CJ Logistics)\nShipping: Free\nDelivery time: 2–4 business days (some items may be delayed depending on circumstances.)\nExchanges/Refunds: Review the exchange and refund terms in the menu below, then submit a return request from your order history page.",
      },
      membership: {
        title: "Membership",
        description: "We're preparing an integrated membership program for use both online and in stores.",
      },
    },
  },
  launches: {
    raffle: {
      title_winning_condition: "(Eligibility)",
      title_raffle_schedule: "(Entry schedule)",
      title_store_info: "(Pickup store and schedule)",
      title_warning_notice: "(Please note)",
      already_entered: "You have already entered this raffle.",
    },
  },
  raffle: {
    entry: {
      description: "All transactions are securely encrypted.<br />Save your payment details to order quickly and easily.",
      online_terms_accept_description:
        "I have reviewed my entry and agree to the raffle terms, and to automatic payment and order processing if I win.",
      offline_terms_accept_description: "I have reviewed my entry and agree to the pickup method and the raffle terms.",
      instagram_invalid_error: "Please enter a valid Instagram ID.",
      online_payment_notice: "If you win the raffle, the payment method you registered will be charged automatically.",
      offline_payment_notice: "If you win the raffle, we will send you the purchase period and instructions via KakaoTalk.",
      instagram_info: "Follow {{storeName}} on Instagram (<instagramLink>{{instagramHandle}}</instagramLink>), then enter your ID.",
      loading_description: "Refreshing or closing this page<br/>may cancel the entry in progress.",
    },
    entered: {
      description:
        "Your entry has been submitted successfully.<br />You can view it on the entry history page, and we'll notify you via KakaoTalk if you win.",
    },
  },
  loading: {
    payment: {
      title: "Your payment is processing.",
      description: "Do not refresh or close your browser.<br/>The payment in process may be canceled.",
    },
  },
  gifting: {
    receive: {
      sender_name: "A gift from {{senderName}}.",
      terms_accept_description: "Agree to the collection of personal information",
      shipping_expire_period: "Address deadline: {{date}}",
      expire_notice: "If you don't accept before the deadline, the order is canceled automatically.",
      status_page_description: "For questions about gifting, please use the chat button at the top.",
      canceled_page_description: "For questions about gifting, please leave us a chat message using the button below.",
      contact: "Contact us",
      canceled: "This gift has been canceled.",
      expired: "This gift has expired.",
      failed: "This gift was canceled at the seller's request.",
    },
  },
  toast: {
    error: {
      default: "A server error occurred. Please try again in a moment.",
    },
    account: {
      success: {
        register: "Successfully signed up.",
        login: "You're now signed in.",
        logout: "You've been signed out.",
        verify: "Identity verification complete.",
        password_reset: "A password reset email has been sent to {{email}}.",
        disable_customer: "Your account has been deleted.",
        modify_account_info: "Your details have been updated.",
      },
      warn: {
        current_password: "Please enter your current password.",
        new_password: "Please enter a new password.",
        confirmed_password: "Please confirm your new password.",
        login_password: "Please enter your current password correctly.",
        match_password: "The new password and confirmation must match.",
        update_new_password: "Please choose a password different from your current one.",
        too_short: "Your password must be at least 5 characters.",
        shipping_address: "Please fill in all address fields.",
        phone_valid: "Please enter a valid phone number.",
        phone_verify: "This phone number is registered to another account. Please sign in with that account.",
        invalid_credentials: "Incorrect email or password.",
        email_account: "This account was created with an email address. Please sign in with email.",
        social_account: "This account was created with {{social}}. Please sign in with {{social}}.",
        social_account_taken: "This email is already registered. Please sign in with {{social}}.",
        social_kakao_script_error: "A Kakao sign-in error occurred. Please try again in a moment.",
        undefined: "Invalid access.",
        end_session: "Your session has expired. Please log in again.",
        request_login: "This page requires a membership check. Please sign in to continue.",
        has_no_access: "Your membership tier doesn't have access.",
      },
      error: {
        register_limit: "Sign-up is delayed due to high traffic. Please try again in a moment.",
        unidentified_customer: "We couldn't find that customer.",
        unidentified_phone: "This account has no registered phone number.",
      },
    },
    product: {
      success: {
        copy_url: "The product URL has been copied to your clipboard.",
      },
      warn: {
        select_size: "Please select a size.",
      },
      error: {
        exceed_qty: "That exceeds the quantity available.",
      },
    },
    wishlist: {
      success: {
        delete_wish_item: "Removed from your wishlist.",
        add_wish_item: "Added to your wishlist.",
      },
    },
    draw: {
      success: {
        entry: "Your entry has been submitted.",
      },
      warn: {
        entry_instagram: "Please enter your Instagram account.",
      },
    },
    checkout: {
      warn: {
        checkout_shipping_address_empty: "You have no saved addresses. Please add one to complete checkout.",
        checkout_shipping_address_blocked:
          "We can't ship to the selected address under our terms of service.\nPlease use a different address.",
        discount_code_valid: "Please enter a discount code.",
      },
      error: {
        discount_code_valid: "That discount code isn't valid.",
        payment_info: "No payment details found. Please try again.",
        payment_complete: "Your payment didn't go through. Please try again.",
      },
    },
    captcha: {
      success: {
        select_letter: "Verification complete.",
      },
      warn: {
        select_letter: "You've selected more letters than allowed.",
        select_wrong_letter: "That answer was incorrect. Please start over.",
        write_wrong_letter: "That answer was incorrect. Please try again.",
      },
    },
  },
  deactivate_account: "Your account has been deleted.",
  close: "Close",
  feedback: {
    title: "Feedback",
    description: "Share your feedback to help us improve your store experience.",
    reward: "Leave your feedback and receive a 10% discount code.",
    leave: "Leave Feedback",
    form_title: "Tell us about your store experience.",
    form_guide: "Select the topics you'd like to give feedback on, then enter your comments.",
    form_multiple: "You can select multiple topics.",
    placeholder: "Enter your comments.",
    submit: "Submit Feedback",
    thanks: "Thank You",
    thanks_description: "Your feedback will help us create a better store experience.",
    thanks_reward: "As a token of our appreciation, here is a 10% discount code for you.",
    copy: "Copy",
    login: "Sign In",
    categories: {
      price: "Product Price & Quality",
      info: "Product Information",
      web: "Store Website Experience",
      delivery: "Shipping",
      discount: "Discounts & Benefits",
      service: "Customer Service",
      etc: "Other",
    },
  },
  toss_policy: {
    "1": "The annual order limit for Toss employee accounts is \u20A92,000,000, and it resets on January 1 each year.",
    "2": "If your cumulative order total plus the items in your cart exceeds the order limit, you cannot place the order. Please adjust the items or amount in your cart.",
    "3": "If an item's own discount rate is higher than the Toss employee discount, only the item's discount rate applies.",
    "4": "Some items are not eligible for the Toss employee discount. Purchases of ineligible items still count toward your cumulative order total.",
    "5": "Toss employee accounts are not eligible for any promotions other than the Toss employee discount.",
    "6": "Upon leaving the company, your account is deactivated on the 1st of the following month. Once deactivated you cannot sign in, so please use the channel talk at the bottom right for any inquiries.",
  },
};

export default en;
